/**
 * GERADO por `apps/web/scripts/guia-capturas.mjs` — não edite à mão.
 *
 * Onde cada marcador numerado cai em cada captura, em % da imagem (centro do alvo, medido no
 * navegador na hora da foto). `null` = o alvo não estava na tela; o guia mostra só a legenda.
 * A ordem é a dos rótulos de `img(...)` em `conteudo.ts`.
 */
export type PosicaoGerada = { x: number; y: number } | null;

export const POSICOES_GERADAS: Readonly<Record<string, readonly PosicaoGerada[]>> = {
  assinatura: [
    {
      x: 26.7,
      y: 53.3,
    },
  ],
  'campanha-grupos': [
    {
      x: 68.2,
      y: 69.1,
    },
    {
      x: 93.1,
      y: 66.9,
    },
  ],
  'campanha-meta': [
    {
      x: 64.2,
      y: 33.5,
    },
    {
      x: 92.6,
      y: 39.1,
    },
    {
      x: 64.2,
      y: 63.5,
    },
  ],
  'campanha-pagina': [
    {
      x: 72.4,
      y: 21.5,
    },
    null,
    {
      x: 28.8,
      y: 59.1,
    },
  ],
  campanhas: [
    {
      x: 92.3,
      y: 23,
    },
    {
      x: 25.2,
      y: 30,
    },
    {
      x: 28.3,
      y: 43.3,
    },
  ],
  'campanhas-desempenho': [
    {
      x: 55.9,
      y: 42.3,
    },
    {
      x: 89.4,
      y: 42.3,
    },
    {
      x: 97,
      y: 42.3,
    },
    {
      x: 27.5,
      y: 47.3,
    },
  ],
  'campanhas-lista': [
    {
      x: 54,
      y: 74.7,
    },
    {
      x: 91,
      y: 80.2,
    },
    {
      x: 95.8,
      y: 80.2,
    },
  ],
  'celular-dashboard': [],
  'celular-grupos': [],
  'celular-menu': [],
  configuracoes: [
    {
      x: 25.2,
      y: 25.4,
    },
    {
      x: 26.7,
      y: 76.6,
    },
    {
      x: 33.1,
      y: 97,
    },
  ],
  'configuracoes-metas': [
    {
      x: 29.4,
      y: 97,
    },
  ],
  contatos: [
    {
      x: 81.9,
      y: 31.6,
    },
    {
      x: 26.4,
      y: 73.4,
    },
    {
      x: 76.6,
      y: 73.4,
    },
  ],
  dashboard: [
    {
      x: 72.4,
      y: 18,
    },
    {
      x: 27,
      y: 32,
    },
    {
      x: 25.2,
      y: 58,
    },
    {
      x: 27,
      y: 47.4,
    },
  ],
  'dashboard-funil': [
    {
      x: 26.7,
      y: 13.3,
    },
  ],
  'dashboard-indicadores': [
    {
      x: 29.1,
      y: 13,
    },
    {
      x: 91.6,
      y: 3,
    },
    {
      x: 64.6,
      y: 13,
    },
  ],
  'dashboard-regiao': [
    {
      x: 26.7,
      y: 24.8,
    },
    {
      x: 29.1,
      y: 30.8,
    },
    {
      x: 63.3,
      y: 45.4,
    },
  ],
  'escuro-dashboard': [],
  gestao: [
    {
      x: 36.4,
      y: 25,
    },
    {
      x: 26.4,
      y: 32.5,
    },
  ],
  'grupo-contatos': [
    {
      x: 26.7,
      y: 13.2,
    },
    {
      x: 26.7,
      y: 28.6,
    },
  ],
  'grupo-detalhe': [
    {
      x: 85.3,
      y: 26,
    },
    null,
    {
      x: 51.4,
      y: 48.9,
    },
  ],
  grupos: [
    {
      x: 92.3,
      y: 18,
    },
    {
      x: 26.7,
      y: 27,
    },
    {
      x: 65.1,
      y: 27,
    },
    {
      x: 67.5,
      y: 39,
    },
  ],
  'grupos-baixar-contatos': [
    {
      x: 33,
      y: 38.5,
    },
    {
      x: 33,
      y: 75,
    },
    {
      x: 31.8,
      y: 79.5,
    },
    {
      x: 33,
      y: 87.6,
    },
  ],
  historico: [
    {
      x: 30.6,
      y: 35.5,
    },
    {
      x: 67.6,
      y: 35.5,
    },
  ],
  'historico-evasao': [
    {
      x: 26.4,
      y: 13.3,
    },
  ],
  incidentes: [
    null,
    {
      x: 89.6,
      y: 29,
    },
    {
      x: 95.8,
      y: 29,
    },
  ],
  membros: [
    {
      x: 26.7,
      y: 39.4,
    },
    {
      x: 92.4,
      y: 39.6,
    },
  ],
  'meta-ads': [
    {
      x: 64.2,
      y: 31.5,
    },
    {
      x: 74.1,
      y: 31.5,
    },
    {
      x: 83.5,
      y: 31.5,
    },
    null,
  ],
  'meta-ads-conectar': [
    {
      x: 35.5,
      y: 39.4,
    },
    {
      x: 35.5,
      y: 53.7,
    },
    {
      x: 39.4,
      y: 67,
    },
  ],
  'meta-ads-tabela': [
    null,
    {
      x: 58.4,
      y: 75.6,
    },
    {
      x: 26.7,
      y: 82.4,
    },
  ],
  'monitorador-novo': [
    {
      x: 38,
      y: 49.5,
    },
    {
      x: 57.9,
      y: 64.8,
    },
  ],
  monitoradores: [
    {
      x: 84.3,
      y: 23,
    },
    {
      x: 11,
      y: 88.6,
    },
    {
      x: 45.4,
      y: 32,
    },
  ],
  'redirecionador-instalacao': [
    {
      x: 64.2,
      y: 17.3,
    },
    null,
  ],
  'redirecionador-novo': [
    {
      x: 35.5,
      y: 29.6,
    },
    {
      x: 35.5,
      y: 43.9,
    },
    null,
  ],
  'redirecionador-quem-clicou': [
    {
      x: 65.2,
      y: 31.1,
    },
    {
      x: 71.9,
      y: 31.1,
    },
    {
      x: 78.3,
      y: 34.1,
    },
  ],
  redirecionadores: [
    {
      x: 85.3,
      y: 20.5,
    },
    {
      x: 90.8,
      y: 55,
    },
    {
      x: 90.8,
      y: 82.8,
    },
    {
      x: 73.7,
      y: 64.9,
    },
  ],
  relatorios: [
    {
      x: 72.9,
      y: 6,
    },
    {
      x: 30.5,
      y: 58.9,
    },
    {
      x: 40.9,
      y: 58.9,
    },
  ],
  shopee: [
    {
      x: 92.5,
      y: 18,
    },
  ],
};
